module.exports = __webpack_public_path__ + "static/media/trump_post.66edeef4.jpg";